'use client'

import type * as React from 'react'

import { cn } from '../../../shared/cn'

export function Label3({
  className,
  htmlFor,
  ...props
}: React.HTMLAttributes<HTMLLabelElement> & { htmlFor?: string }) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor is passed via spread props from parent components
    <label
      data-slot='label'
      htmlFor={htmlFor}
      className={cn(
        'font-medium text-contentPrimary',
        'text-sm/5',
        'flex select-none items-center gap-2 font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
        className
      )}
      {...props}
    />
  )
}
